export const DEFAULT_DATE_FORMAT = "dd MMM yyyy";
export const DEFAULT_MIN_DATE = new Date("01/01/2021");
export const DEFAULT_MAX_DATE = new Date("12/31/2030");
